import { useMutation, useQueryClient } from 'react-query'
import { QueryNames } from 'Hooks/api/queryNames'
import { toast } from 'react-toastify'
import { AppNotification } from 'Utils/types/appNotification'
import { deleteMetaField } from 'Services/JOONAdmin/joonAdminEmployersService'

export const useDeleteMetaFieldQuery = () => {
  const queryClient = useQueryClient()

  return useMutation([QueryNames.DeleteMetaField], deleteMetaField, {
    onSuccess: (response) => {
      if (response.success) {
        queryClient.invalidateQueries([QueryNames.EmployerMetaFields])
        queryClient.invalidateQueries([QueryNames.UsersForEmployer])
        queryClient.invalidateQueries([QueryNames.UsersWithMetadata])
        toast.success(AppNotification.DeleteMetaFieldSuccess)
      } else {
        toast.error(response.message || AppNotification.DeleteMetaFieldFailure)
      }
    },
    onError: () => {
      toast.error(AppNotification.DeleteMetaFieldFailure)
    }
  })
}
